import shortid from 'shortid'
/**
 * 筛选项
 */
export interface Filter {
  label: string
  key: string
  value: number
  children?: Filter[]
}

interface Context {
  parent?: FilterTree
  top?: FilterTree
  vm?: any
}

export class FilterTree {
  label: string
  key: string
  value: number
  children: FilterTree[]
  cursorValue: number = 0
  parent: FilterTree | null
  top: FilterTree
  _id: string

  get cursorSubTree(): FilterTree | undefined {
    return this.children.find(tree => tree.value === this.cursorValue)
  }
  //  是否是叶子节点
  get isLeaf(): boolean {
    return !this.children || !this.children.length
  }

  get query(): any {
    if (this.isLeaf) {
      return {}
    }
    if (!this.cursorSubTree) {
      return {}
    }
    const { key, value, query } = this.cursorSubTree
    const _query = query ? query : {}

    if (query.hasOwnProperty(key) && query[key] === 0) {
      return {
        ..._query,
        [key]: value
      }
    }
    return {
      [key]: value,
      ..._query
    }
  }

  get shownFilterList(): FilterTree[] {
    if (this.isLeaf) {
      return []
    }
    if (!this.cursorSubTree) {
      return [this]
    }
    return [this, ...this.cursorSubTree.shownFilterList]
  }

  get placeholder() {
    if (this.isLeaf) {
      return ''
    }
    return this.children[0].label
  }

  constructor(options: Filter, context: Context) {
    this._id = shortid.generate()
    const { parent, top, vm } = context
    this.parent = parent || null
    this.top = top || this
    const { label, key, value } = options
    let children = options.children
    if (children && children[0] && children[0].value !== 0) {
      children = [
        {
          label: '-全部-',
          value: 0,
          key: children[0].key
        },
        ...children
      ]
    }
    this.label = label
    this.key = key
    this.value = value
    this.children = (children || []).map(
      el =>
        new FilterTree(el, {
          parent: this,
          top: this.top
        })
    )
  }

  reset() {
    this.resetSubTree()
    this.resetCursor()
  }

  resetCursor() {
    this.cursorValue = 0
  }

  resetSubTree() {
    if (this.cursorSubTree) {
      this.cursorSubTree.reset()
    }
  }

  select(optionValue: number) {
    if (this.cursorValue === optionValue) {
      return
    }
    this.cursorValue = optionValue
    this.resetSubTree()
  }
}
